import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useState, SyntheticEvent } from 'react';
import { useHelpModalState } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';

const usePeriod = (nextUrl: string) => {
  const { t } = useTranslation('period');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const currentYear = new Date().getFullYear();
  const [monthFrom, setMonthFrom] = useState<number>(1);
  const [monthTo, setMonthTo] = useState<number>(12);
  const [yearFrom, setYearFrom] = useState<number>(currentYear - 1);
  const [yearTo, setYearTo] = useState<number>(currentYear - 1);

  const listOfMonths = [
    { value: 1, title: 'Jan' },
    { value: 2, title: 'Feb' },
    { value: 3, title: 'Mär' },
    { value: 4, title: 'Apr' },
    { value: 5, title: 'Mai' },
    { value: 6, title: 'Jun' },
    { value: 7, title: 'Jul' },
    { value: 8, title: 'Aug' },
    { value: 9, title: 'Sep' },
    { value: 10, title: 'Okt' },
    { value: 11, title: 'Nov' },
    { value: 12, title: 'Dez' },
  ];

  const getRange = (start: number, end: number) => Array.from({ length: end - start }, (v, k) => k + start);

  const listOfYears = getRange(2012, currentYear + 1).map((year: number) => ({ value: year, title: year }));

  const onMonthFromChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setMonthFrom(Number(target.value));
  };

  const onYearFromChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setYearFrom(Number(target.value));
  };

  const onMonthToChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setMonthTo(Number(target.value));
  };

  const onYearToChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setYearTo(Number(target.value));
  };

  const onSubmit = () => {
    dispatchQuestion('periodMonthFrom', monthFrom);
    dispatchQuestion('periodYearFrom', yearFrom);
    dispatchQuestion('periodMonthTo', monthTo);
    dispatchQuestion('periodYearTo', yearTo);

    history.push(nextUrl);
  };

  const onSkip = () => {
    dispatchQuestion('periodMonthFrom', '');
    dispatchQuestion('periodYearFrom', '');
    dispatchQuestion('periodMonthTo', '');
    dispatchQuestion('periodYearTo', '');

    history.push(nextUrl);
  };

  return {
    classes: useStyles(),
    t,
    listOfMonths,
    listOfYears,
    monthFrom,
    yearFrom,
    monthTo,
    yearTo,
    onMonthFromChange,
    onYearFromChange,
    onMonthToChange,
    onYearToChange,
    onSubmit,
    onSkip,
    toggleHelpModal,
  };
};

export default usePeriod;
